import '~/js/modules/section-hero';
import 'slick-carousel';
import GoFetch from '~/js/modules/fetch-wrapper.js';
const fetch = new GoFetch();

function addContentToPopup(content) {
  const offerDetailsPopup = document.querySelector('#offer-details-popup');
  const top = '<h4>offer details</h4>';
  const title = `<h3>${content.title}</h3>`;

  offerDetailsPopup.innerHTML = top + title + content.description;
}

fetch.post('/fetchPromotion/?promo_ids=115577 ', null)
  .then(response => addContentToPopup(response.data.promotions[0].promotion));


// Sliders
const bboSlider = $('.js-bbo-slider').slick({
  initialSlide: 20,
  slidesToShow: 1,
  slidesToScroll: 1,
  speed: 500,
  prevArrow: '<button aria-label="Previous" class="prev resort-slider-arrow"><i class="icon icon-button-arrow-prev"></i></button>',
  nextArrow: '<button aria-label="Next" class="next resort-slider-arrow"><i class="icon icon-button-arrow-next"></i></button>'
});

bboSlider.on('beforeChange', (event, slick, currentSlide, nextSlide) => {
  const nextImg = slick.$slides[nextSlide];
  const srcImg = nextImg.dataset.src;

  nextImg.src = srcImg;
  nextImg.addEventListener('load', () => {
    nextImg.style.opacity = 1;
  });
});
